/// <amd-module name="Build/Common/Library/Stores/Permissions" />
import { ContributionSource } from "Build/Flux/Sources/Contribution";
import { Store } from "Build/Flux/Store";

import { IVssPageContext } from "VSS/Platform/Context";

export interface IPermissionStoreOptions {
    pageContext: IVssPageContext;
    source?: ContributionSource;
}

const s_sharedKey = "_permissions";
const s_claimsKey = "ms.vss-web.user-claims-data";

// Stores permissions added to DataProviderContext's SharedData
// Note: This just depends on the permissions available in json land, doesn't "fetch" permissions if it doesn't exist...
//       ...if it has to, then Vssf/WebPlatform/Platform/Scripts/VSS/Security/RestClient.ts should be exposed to probably Vssf/Web/extensions/vss-features...
//       ...and then used here
export class PermissionsStore extends Store {
    private _permissions: { [key: string]: { [key: string]: number } };
    private _claims: { [key: string]: boolean };

    constructor(options: IPermissionStoreOptions) {
        super();
        const source = (options.source) ? options.source : new ContributionSource({
            pageContext: options.pageContext
        });
        this._permissions = source.getSharedData(s_sharedKey) || {};
        this._claims = source.getData(s_claimsKey) || {};
    }

    public hasPermission(namespace: string, token: string, requestedPermission: number): boolean {
        if (this._permissions)
        {
            const tokens = this._permissions[namespace];
            if (tokens) {
                const effectivePermissions = tokens[token];
                if (effectivePermissions === undefined) {
                    console.warn("PermissionsStore: token " + token + ", for namespace" + namespace + ", has no permissions defined.");
                }

                return (requestedPermission & effectivePermissions) > 0;
            }
            else {
                console.warn("PermissionsStore: namespace " + namespace + "has no permissions defined.");
            }
        }

        return false;
    }

    public hasClaim(claim: string) {
        return !!(this._claims && this._claims[claim]);
    }
}
